/* * @Author: 曹俊杰 * @Date: 2023-01-10 17:04:13 * @Module: 用户认证 */
<template>
  <div class="userAuth">
    <div class="daohang">
      <div class="daohang_l">
        <div class="l_1">个人实名</div>
        <div class="l_2">/</div>
        <div class="l_3">填写个人信息</div>
      </div>
      <div class="daohang_r">完成个人实名后，可进行企业认证</div>
    </div>
    <div class="top">
      <img src="~@/assets/image/icon_3.png" alt="" srcset="" />
      <p>中能E签保证您的信息安全，信息仅用于身份验证</p>
    </div>
    <div class="content">
      <div class="step1" v-show="step === 1">
        <div class="title">
          <i
            class="el-icon-ali-gerenshiming"
            style="color: #0062ff; margin-right: 6px"
          ></i>
          <span>个人实名信息</span>
        </div>
        <div class="dsc">
          <p>应电子签名相关法律要求，请补充个人真实信息以确保签署者的真实身份</p>
          <p>提高电子合同的安全性和法律效力，以及保护交易双方的权益</p>
        </div>
        <el-form
          ref="form"
          label-position="top"
          :model="form"
          label-width="84px"
          :rules="rules"
          size="medium"
        >
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入您的姓名"></el-input>
          </el-form-item>
          <el-form-item label="证件类型" prop="idType">
            <el-select
              v-model="form.idType"
              style="width: 100%"
              placeholder="选择您的证件类型"
            >
              <el-option
                v-for="item in idType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <!-- <el-input v-model="form.representativeIdType" placeholder="选择您的法人代表证件类型"></el-input> -->
          </el-form-item>
          <el-form-item label="证件号" prop="idNumber">
            <el-input v-model="form.idNumber" placeholder="请输入您的证件号"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入您的手机号"></el-input>
          </el-form-item>
        </el-form>

        <div class="btns">
          <el-button  @click="$router.go(-1)">取消</el-button>
          <el-button  @click="postAccountAuth" type="primary">提交</el-button>
        </div>
      </div>

      <div class="step3" v-show="step === 2">
        <div class="step3_icon">
          <img src="@/assets/image/success.png" alt="" srcset="" />
          <div class="step3_icon_title">认证成功</div>
          <div class="step3_icon_desc">恭喜您个人实名认证成功</div>
        </div>
        <div class="btns" style="margin-top: 16px">
          <!-- <el-button class="button" >
            回到首页
          </el-button> -->
          <el-button
            class="button"
            type="primary"
            @click="$router.push({ name: 'home' })"
          >
            返回首页
          </el-button>
        </div>
      </div>
      <saomarenzheng ref="saomarenzhengRef" @success="showSuccess" />
    </div>
  </div>
</template>
<script>
// import authStep from '@/components/authStep'

import { mapState } from "vuex";
import selectData from "@/mixins/selectData.js";
import saomarenzheng from "@/components/saomarenzheng/index.vue";
export default {
  components: {
    // authStep,
    saomarenzheng,
  },
  mixins: [selectData],
  data() {
    const phoneValidator = (_, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      }
      if (this.$utils.test.mobile(value)) {
        return callback();
      } else {
        return callback(new Error("请输入正确的手机号"));
      }
    };
    return {
      step:1,
      loading: false,
      form: {
        name: "",
        idNumber: "",
        idType: "",
        phone: "",
      },
      authUrl: "",
      rules: {
        name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        idType: [{ required: true, message: "证件类型不能为空", trigger: "blur" }],
        phone: [{ required: true, validator: phoneValidator, trigger: "blur" }],
        idNumber: [{ required: true, message: "证件号不能为空", trigger: "blur" }],
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
    }),
  },
  mounted() {
    this.form.phone = this.user.phone;
  },
  methods: {
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.postAccountAuth();
        } else {
          return false;
        }
      });
    },

    showSuccess() {
      this.step = 2;
    },
    async postAccountAuth() {
      this.loading = true;
      const { status, info, data } = await this.$api.postAccountAuth(this.form);
      if (status == 200) {
        this.$message({
          type: "success",
          message: info,
        });
        this.$refs.saomarenzhengRef.onshow({...this.form,...data})
      } else {
        this.$message({
          type: "error",
          message: info,
        });
      }
      this.loading = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.userAuth {
  @include contentStyle4;
  // flex-direction: column;
  .daohang {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 54px;
    &_l {
      display: flex;
      align-items: center;
      .l_1 {
        font-family: "Noto Sans SC";
        font-size: 14px;
        font-weight: 350;
        line-height: normal;
        letter-spacing: 0em;

        font-variation-settings: "opsz" auto;
        font-feature-settings: "kern" on;
        color: #999999;
      }
      .l_2 {
        font-family: "Noto Sans SC";
        font-size: 14px;
        font-weight: 350;
        line-height: normal;
        letter-spacing: 0em;

        font-variation-settings: "opsz" auto;
        font-feature-settings: "kern" on;
        color: #999999;
        margin: 0 10px;
      }
      .l_3 {
        font-family: "Noto Sans SC";
        font-size: 16px;
        font-weight: normal;
        line-height: normal;
        letter-spacing: 0em;

        font-variation-settings: "opsz" auto;
        font-feature-settings: "kern" on;
        color: #262626;
      }
    }
    &_r {
      font-family: "Noto Sans SC";
      font-size: 14px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0em;

      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;
      color: #262626;
    }
  }
  .top {
    background: #fff;
    height: 40px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    gap: 7.5px;
    line-height: 0;
    font-size: 14px ;
    img {
      width: 10.5px;
      height: 13px;
    }
  }

  .content {
    margin-top: 16px;
    padding-top: 30px;
    background: #ffffff;
    border-radius: 4px;
    padding-bottom: 56px;
    width: 100%;
    @include formStyle;
    .title {
      text-align: center;

      color: #262626;
      font-family: "Noto Sans SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 23px;
    }

    .dsc {
      color: #999;
      text-align: center;
      font-family: "Noto Sans SC";
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 26px;
      /* 185.714% */
      margin-bottom: 20px;
      margin-top: 10px;
      line-height: 1.7;
    }

    .btns {
      display: flex;
      align-items: center;
      justify-content: center;
      .button {
        @include buttonStyle;
      }
    }

    .step1 {
      width: 444px;
      margin: 0 auto;
    }

    .step2 {
      display: flex;
      flex-direction: column;
      align-items: center;

      .dec {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #666666;
        margin-top: 19px;
      }
    }
    .step3 {
      &_icon {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 14px;
        &_title {
          font-family: "Noto Sans SC";
          font-size: 14px;
          font-weight: 500;
          line-height: 22px;

          font-variation-settings: "opsz" auto;
          color: #1d2129;
          margin-top: 16px;
        }
        &_desc {
          font-family: "Noto Sans SC";
          font-size: 14px;
          font-weight: normal;
          line-height: 22px;
          letter-spacing: 0px;

          color: #86909c;
        }
        img {
          width: 48px;
          height: 48px;
        }
      }
    }
  }
}
</style>
